// Firebase SDK initialization with Local Dev / Offline Fallback Support
import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';

// Default / fallback Firebase config
// When connecting to your production Firebase project, replace or configure via .env
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyA9PEsXSA1wN9VI3Wx1NV_8Z1ZQN1l6wp8",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "popsculture.dad",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "project-dad-a0a5f",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "project-dad-a0a5f.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "112915550141",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:112915550141:web:624c8bfcec37269e30ccd4"
};

let app: FirebaseApp;
let auth: Auth;
let db: Firestore;
let isConfigured = Boolean(import.meta.env.VITE_FIREBASE_PROJECT_ID);

try {
  if (!getApps().length) {
    app = initializeApp(firebaseConfig);
  } else {
    app = getApps()[0];
  }
  auth = getAuth(app);
  db = getFirestore(app);
} catch (error) {
  console.warn('[Pops Culture] Initializing Firebase with local fallback mode:', error);
  app = {} as unknown as FirebaseApp;
  auth = {} as unknown as Auth;
  db = {} as unknown as Firestore;
}

export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

export { app, auth, db, isConfigured };
